import React from "react";
import styles from "./Title.module.css";

const Title = ({ title, para }) => {
  return (
    <div className={`title ${styles.title}`}>
      <h1>{title}</h1>
      <div dangerouslySetInnerHTML={{ __html: para }} />
    </div>
  );
};

export default Title;
